export const iconTextDictionary = [
  "Poor (not possible)",
  "Fair (needs customization or limited)",
  "Good (partially available, e.g. plugins)",
  "Excellent (fully available)",
]
